import * as React from 'react'

import { CopilotKit } from '@copilotkit/react-core'
import { CopilotChat } from '@copilotkit/react-ui'
import '@copilotkit/react-ui/styles.css'
import { Box } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/factorial-one-react/dist/experimental'
import { EnvironmentContext } from 'config/environment'
import { AiWidgetDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const AiAgent = () => {
  const { mastraLocation } = React.useContext(EnvironmentContext)
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(AiWidgetDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const hasFeature = data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_ai_agent'
  )?.enabled

  if (loading || !hasFeature) {
    return null
  }

  return (
    <Widget header={{ title: '(almost) One' }}>
      <Box overflowY="auto" flexGrow padding="s24" gap="s24">
        <CopilotKit
          runtimeUrl={`${mastraLocation}/copilotkit`}
          agent="one"
          credentials="include"
          showDevConsole
        >
          <CopilotChat
            labels={{
              title: 'One',
              initial: 'Hi! 👋 How can I assist you today?',
            }}
          />
        </CopilotKit>
      </Box>
    </Widget>
  )
}
